export default __webpack_public_path__ + "fonts/KFOlCnqEu92Fr1MmEU9fABc4EsA.woff2";